import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteSettingsProvider } from "@/context/SiteSettingsContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import HomePage from "@/pages/HomePage";
import { RaceReportsListPage, RaceReportDetailPage } from "@/pages/RacePages";
import { NewsListPage, NewsDetailPage } from "@/pages/NewsPages";
import DriversPage from "@/pages/DriversPage";
import StandingsPage from "@/pages/StandingsPage";
import CalendarPage from "@/pages/CalendarPage";
import RoadmapPage from "@/pages/RoadmapPage";
import CardRevealPage from "@/pages/CardRevealPage";
import { ImpressumPage, DatenschutzPage } from "@/pages/LegalPages";
import LoginPage from "@/pages/LoginPage";
import AdminPage from "@/pages/AdminPage";
import DnfCounterBadge from "@/components/DnfCounterBadge";
import "@/App.css";

export default function App() {
  return (
    <AuthProvider>
      <SiteSettingsProvider>
        <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/rennberichte" element={<RaceReportsListPage />} />
            <Route path="/rennberichte/:slug" element={<RaceReportDetailPage />} />
            <Route path="/news" element={<NewsListPage />} />
            <Route path="/news/:slug" element={<NewsDetailPage />} />
            <Route path="/fahrer" element={<DriversPage />} />
            <Route path="/wertung" element={<StandingsPage />} />
            <Route path="/kalender" element={<CalendarPage />} />
            <Route path="/roadmap" element={<RoadmapPage />} />
            <Route path="/karten-reveal" element={<CardRevealPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={
              <ProtectedRoute><AdminPage /></ProtectedRoute>
            } />
          </Route>
        </Routes>
      </BrowserRouter>
      <DnfCounterBadge />
      </SiteSettingsProvider>
      <Toaster position="top-right" theme="dark" richColors closeButton />
    </AuthProvider>
  );
}
